<template>
  <Header />
  <Content />

  <div
    v-if="!isLoggedIn && currentRoute.path != '/login'"
    class="container is-max-desktop login-page"
  >
    <h2>Login for medlemmer</h2>
    <LoginButtons />
  </div>

  <div v-if="isLoggedIn" class="container is-max-desktop login-page">
    <h1>Du er logget ind</h1>
    <p>Åbner bookingsystemet...</p>
  </div>

  <form
    v-if="currentRoute.path == '/login'"
    class="container is-max-desktop login-page"
    method="post"
    action="/login"
    @submit.prevent="submitPasswordLogin"
  >
    <h2>Login med mail + kode</h2>
    <div class="form-section max-width">
      <div class="field">
        <div class="control">
          <label for="email">E-mail</label>
          <input
            v-model="email"
            class="input"
            type="email"
            id="email"
            name="email"
            autocomplete="username"
            required
          >
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label for="password">Adgangskode</label>
          <input
            v-model="password"
            class="input"
            type="password"
            id="password"
            name="password"
            autocomplete="current-password"
            required
          >
        </div>
      </div>
      <p v-if="loginError" class="help is-danger">{{ loginError }}</p>
      <button class="button is-success" type="submit" :disabled="submitting">Log ind</button>
    </div>
  </form>

  <Footer />
</template>

<script>
import { defineComponent, computed, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useComposition } from '@/compositions/composition'
import { authRoutes } from '@/auth/config'
import { loginWithPassword, redirectHome, friendlyError } from '@/auth/sessionApi'

import Header from '@/components/Header.vue'
import LoginButtons from '@/components/LoginButtons.vue'
import Footer from '@/components/Footer.vue'
import Content from '@/components/Content.vue'

export default defineComponent({
  components: {
    Header,
    LoginButtons,
    Footer,
    Content
  },
  setup() {
    const { global } = useComposition()
    const router = useRouter()
    const route = useRoute()
    const email = ref('')
    const password = ref('')
    const loginError = ref('')
    const submitting = ref(false)

    const isLoggedIn = computed(() =>
      global.value.user && Object.prototype.hasOwnProperty.call(global.value.user, 'id')
    )

    const currentRoute = computed(() => route)

    onMounted(() => {
      setTimeout(() => {
        if (!global.value.user || !Object.prototype.hasOwnProperty.call(global.value.user, 'attentionBookings')) {
          return
        }
        const url = global.value.user.attentionBookings.length === 0
          ? authRoutes.calendar
          : authRoutes.myBookings
        router.push(url)
      }, 500)
    })

    const submitPasswordLogin = async () => {
      loginError.value = ''
      submitting.value = true
      try {
        const data = await loginWithPassword(email.value, password.value)
        if (data && data.success) {
          redirectHome()
          return
        }
        loginError.value = 'Forkert e-mail eller adgangskode.'
      } catch (error) {
        loginError.value = friendlyError(error, 'Login fejlede. Prøv igen.')
      } finally {
        submitting.value = false
      }
    }

    return {
      global,
      email,
      password,
      loginError,
      submitting,
      isLoggedIn,
      currentRoute,
      submitPasswordLogin
    }
  }
})
</script>
